<div class="wrapper">
  <app-shared-favorite-property
    *ngIf="property"
    [property]="property"
  ></app-shared-favorite-property>

  <a
    *ngIf="property"
    [routerLink]="routerLink"
    [queryParams]="queryParams"
    class="property-info"
    target="_blank"
    [ngClass]="{ disabled: shareModalOpen }"
  >
    <app-property-list-label [property]="property"></app-property-list-label>
    <div class="images">
      <!-- <img
        [src]="thumbnail"
        alt="property image"
        class="thumbnail"
        loading="lazy"
      /> -->
      <img
        *ngIf="image"
        [src]="image"
        alt="property image"
        class="small"
        loading="lazy"
      />
      <div class="property-type subtype">
        {{ property.subType | stringTransform: 'capitalizeFirstLetter' }}
      </div>
      <app-property-share-button
        *ngIf="isLoggedIn"
        (handleOpen)="this.openShareModal.emit(this.property)"
      ></app-property-share-button>
    </div>

    <app-shared-property-list-info
      [property]="property"
    ></app-shared-property-list-info>
  </a>
</div>
